import * as queries from "@queries/utils";

export const downloadWord = () => queries.getQuery("/api/Devis");
